import { getDefaultPrismId, generateNonce } from '../utilities/CommonHelperUtil';
import { makeServiceCall, logGenericError } from '../utilities/ServiceHelperUtil';
const fetchIDSToken = async () => {
    const url = `ids-token?nonce=${generateNonce()}`;
    const eventName = 'fetchIDSToken';
    try {
        return await makeServiceCall({
            eventName: eventName,
            url: url,
            method: 'GET',
            useProxy: true
        });
    } catch (error) {
        return error;
    }
};

const fetchContactProfile = async (emailAddress, ciamId, prismId, token) => {
    const eventName = 'fetchAgentPortalProfile';
    let url = 'contact-profile';
    let useProxy = true;
    try {
        if(token) {
            useProxy = false;
        }
        if(prismId) {
            url = `${url}?prismId=${prismId}`;
        } else {
            url = `${url}?emailAddress=${emailAddress}&ciamId=${ciamId}`;
        }
        // Only append nonce if the base URL is AGSS_PROXY_BASE_URL
        if (!token) {
            url += `&nonce=${generateNonce()}`;
        }
        const data = await makeServiceCall({
            eventName: eventName,
            url: url,
            method: 'GET',
            token: token,
            useProxy: useProxy
        });

        if(!data?.success) {
            return data.errorMessage;
        }
        if(data?.profile && data?.profile?.enrollments?.length > 1) {
            data.profile.enrollments = getDefaultPrismId(data.profile.enrollments);
        }
        return data?.profile;
    } catch (error) {
        logGenericError(url, eventName, error)
    }
}

const fetchVerifyUser = async (userData) => {
    const eventName = 'fetchVerifyUser';
    const url = `verify-user?prismId=${userData.username.toLowerCase()}&dob=${userData.dateofbirth ? userData.dateofbirth : ''}&npn=${userData.npn ? userData.npn : ''}&nonce=${generateNonce()}`;
    try {
        return await makeServiceCall({
            eventName: eventName,
            url: url,
            method: 'GET',
            useProxy: true
        });
    } catch (error) {
        logGenericError(url, eventName, error)
    }
}

const fetchVerifyUserEncrypt = async (userData) => {
    const eventName = 'fetchVerifyUserEncrypt';
    const url = `verify-user-encrypt?prismId=${userData.username.toLowerCase()}&dob=${userData.dateofbirth ? userData.dateofbirth : ''}&npn=${userData.npn ? userData.npn : ''}&nonce=${generateNonce()}`;
    try {
        return await makeServiceCall({
            eventName: eventName,
            url: url,
            method: 'GET',
            useProxy: true
        });
    } catch (error) {
        logGenericError(url, eventName, error)
    }
}

const fetchDomain = async (mngGrp) => {
    const encodedMngGrp = encodeURIComponent(mngGrp);
    const eventName = 'fetchDomain';
    const url = `fetch-domain?mngGrp=${encodedMngGrp}&nonce=${generateNonce()}`;
    try {
        return await makeServiceCall({
            eventName: eventName,
            url: url,
            method: 'GET',
            useProxy: true
        });
    } catch (error) {
        logGenericError(url, eventName, error)
    }
}

const modernLinkRedirect = async (userId, policyNumber, gpa, pc, addtQueryParams) => {
    addtQueryParams = addtQueryParams !== undefined && addtQueryParams !== null ? '&' + addtQueryParams : '';
    const eventName = 'modernLinkRedirect';
    const url = `modernlink-redirect?userId=${userId}&policyQuoteNumber=${policyNumber}&gpa=${gpa}&pc=${pc}${addtQueryParams}&nonce=${generateNonce()}`;
    try {
        return await makeServiceCall({
            eventName: eventName,
            url: url,
            method: 'GET',
            useProxy: true
        });
    } catch (error) {
        logGenericError(url, eventName, error)
    }
}

const gwLinkRedirect = async (userId, policyNumber, gpa, pc, addtQueryParams) => {
    addtQueryParams = addtQueryParams !== undefined && addtQueryParams !== null ? '&' + addtQueryParams : '';
    const eventName = 'gwLinkRedirect';
    const url = `gwlink-redirect?userId=${userId}&policyQuoteNumber=${policyNumber}&gpa=${gpa}&pc=${pc}${addtQueryParams}&nonce=${generateNonce()}`;
    try {
        return await makeServiceCall({
            eventName: eventName,
            url: url,
            method: 'GET',
            useProxy: true
        });
    } catch (error) {
        logGenericError(url, eventName, error)
    }
}

const encryptMessage = async (message) => {
    const eventName = 'encryptMessage';
    const url = `encrypt-message?message=${message}&nonce=${generateNonce()}`;
    try {
        return await makeServiceCall({
            eventName: eventName,
            url: url,
            method: 'GET',
            useProxy: true
        });
    } catch (error) {
        logGenericError(url, eventName, error)
    }
};

export { fetchIDSToken, fetchContactProfile, fetchVerifyUser, fetchVerifyUserEncrypt, fetchDomain, modernLinkRedirect, gwLinkRedirect, encryptMessage };
